module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/ico_close-44cc0ab1d48cd0edcfe6f64156d17d6b.svg";